<template lang="pug">
.modal-card
  header.modal-card-head
    p.modal-card-title(data-qa="modal-header") 
      span.icon.mr-2.is-clickable(v-if="hasPrevious" @click="prevStep()" )
        i.mdi.mdi-arrow-left.mdi-24px
      b(v-t="'appointment.find_slot_title'")
    div
      a.button.is-white.is-small(@click="$emit('close')")
        span.icon
          i.mdi.mdi-close.mdi-24px
  section.modal-card-body.p-0.is-flex.is-align-items-stretch(style="width: 100%")
    em-loading(:active="loading" :is-full-page="false")
    LocationListSelect(@input="onLocationSelect" v-if="step === 'location'" style="width: 100%")
    
    SlotFinderServiceSelector(v-else-if="step === 'service'" 
      :locationId="currentLocationId" 
      @input="onServiceSelect" 
      style="width: 100%")
    
    StaffMembersSelect(v-else-if="step === 'staff'" 
      :rangesByDay="rangesByDay" 
      :bookedResources="bookedResources" 
      :availableRanges="availableRanges" 
      :services="services"
      :potentialResources="potentialResources"  
      :potentialStaff="potentialStaff"  
      @input="onStaffSelect" 
      :locationId="currentLocationId")
    
    SlotSelector(v-else-if="step === 'slot'" 
      :rangesByDay="rangesByDay" 
      :bookedResources="bookedResources" 
      :availableRanges="availableRanges" 
      :services="services" 
      :from="from" 
      :to="to" 
      :staffIds="staffIds" 
      :potentialResources="potentialResources"  
      @input="onSlotSelect")

    
  footer.modal-card-foot
    button.button.is-primary.is-fullwidth.is-justify-content-space-between(@click="nextStep" v-if="step === 'service' && services.length")
      b(v-t="'actions.next'") 
      b(style="border: 2px solid white; border-radius: 999px; width: 1.75rem; display: inline-block;") {{services.length}}
    //service-name-view.is-flex-grow-1(:value="{service: selectedService.serviceId, option: selectedService.optionId}" v-if="selectedService")
    action-button(v-else-if="step === 'slot'" :disabled="!slot" title="actions.select" @click="onSubmit")
    
</template>
<script>
import AppointmentsApi from '@/api/appointments'
import LocationListSelect from '../location/LocationListSelect'
import StaffMembersSelect from './StaffMembersSelect'
import SlotFinderServiceSelector from './SlotFinderServiceSelector'
import SlotSelector from './SlotSelector'
import dayjs from 'dayjs'
import {mapGetters} from 'vuex'
//import saleHelper from '../../../shared/saleHelper'

export default {
  name: 'SlotFinder',
  components: {
    LocationListSelect,
    StaffMembersSelect,
    SlotFinderServiceSelector,
    SlotSelector
  },
  data() {
    return {
      step: 'service',
      steps: ['service', 'staff', 'slot'],
      loading: false,
      currentLocationId: undefined,
      services: [],
      potentialStaff: [],
      potentialResources: [],
      availableRanges: undefined,
      bookedResources: undefined,
      rangesByDay: undefined,
      slot: undefined,
      staffIds: undefined,
      from: parseInt(dayjs().format('YYYYMMDD')),
      to: parseInt(
        dayjs()
          .add(1, 'month')
          .format('YYYYMMDD')
      )
    }
  },
  computed: {
    ...mapGetters('location', ['hasMultipleLocations', 'activeLocations']),
    hasPrevious() {
      return this.steps.indexOf(this.step) > 0
    }
  },
  created() {
    if (this.hasMultipleLocations) {
      this.steps.unshift('location')
      this.step = 'location'
    } else {
      this.currentLocationId = this.activeLocations[0]._id
    }
  },
  methods: {
    async nextStep() {
      if (this.step === 'service') {
        await this.loadAppointments()
      }
      this.step = this.steps[this.steps.indexOf(this.step) + 1]
    },
    prevStep() {
      this.step = this.steps[this.steps.indexOf(this.step) - 1]
    },
    onSlotSelect(slot) {
      this.slot = slot
    },
    onSubmit() {
      this.slot.services.forEach(s => {
        s.staff = this.slot.staff[0]
      })

      this.$emit('input', {services: this.slot.services, start: this.slot.start, locationId: this.currentLocationId})
      this.$emit('close')
    },
    onLocationSelect(locationId) {
      this.currentLocationId = locationId
      this.nextStep()
    },
    async onServiceSelect({services, staff, resources}) {
      this.services = services
      this.potentialStaff = staff
      this.potentialResources = resources
    },
    async loadAppointments() {
      this.loading = true
      try {
        const [availableRanges, bookedResources] = await Promise.all([
          AppointmentsApi.getStaffAvailableRanges({location: this.currentLocationId, from: this.from, to: this.to}),
          AppointmentsApi.getBookedSlotsByResource({location: this.currentLocationId, from: this.from, to: this.to})
        ])
        this.availableRanges = availableRanges
        this.bookedResources = bookedResources
        let rangesByDay = {}
        for (let staffId in availableRanges) {
          for (let day in availableRanges[staffId]) {
            rangesByDay[day] = rangesByDay[day] || {}
            rangesByDay[day][staffId] = availableRanges[staffId][day]
          }
        }
        this.rangesByDay = rangesByDay
      } catch (err) {
        this.$handleAPIError(err)
      }
      this.loading = false
    },
    resetSelectedServices() {
      this.services = []
      this.potentialStaff = []
      this.potentialResources = []
    },

    onStaffSelect(staffIds) {
      this.staffIds = staffIds
      this.nextStep()
    }
  }
}
</script>
